import React from "react";
import { isValidDate } from "../../helpers/validators";
import { notificarError } from "../Almacenes/AlmacenNotify";
import { convertObjToQueryParams } from "../../helpers/utils";
import ReactExport from "react-data-export";
import { getConfExcelForDocReport } from "../../helpers/reports";
import FiltroReportDocSunat from "../ReporteDocSunat/FiltroReportDocSunat";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export default class ReporteDocNavasoftScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataReport: [],
            isLoading: false
        }
        this.onfilterPressedHandler = this.onfilterPressedHandler.bind(this);
    } 

    onfilterPressedHandler(payload) {
        if(isValidDate(payload.fechaInicio) && isValidDate(payload.fechaFin)){
            // CORRECTO: verificar el array de sucursales
            payload._sucursales && payload._sucursales.length ? this.fetchDataReport(payload) : notificarError("Debe seleccionar al menos una sucursal")
        } else{
            notificarError("Las fechas ingresadas son incorrectas")
        }
    }
    async fetchDataReport(payload){
        this.setState({isLoading: true, dataReport: []})
        let res = await fetch(`/api/reportes/docs-navasoft?${convertObjToQueryParams(payload)}`)
        if(res.ok){
            let data = await res.json();
            this.setState({dataReport: data})
        } else {
            notificarError("Se ha produccido un error al momento de extraer datos.")
        }
        this.setState({isLoading: false})
    }
    sanitizeValue(value, decimals) {
        if (value === null || value === undefined) {
            return "";
        }
        if (typeof value === "number") {
            return typeof decimals === "number" ? value.toFixed(decimals) : value;
        }
        if (typeof value === "string") {
            let num = Number(value);
            if (!isNaN(num) && typeof decimals === "number") {
                return num.toFixed(decimals);
            }
            return value.trim().replace(/[\x00-\x1F\x7F-\x9F]/g, "");
        }
        return String(value);
    }

    getConfigReport(dataReport) {

    return [
        {
            columns: [
                { title: "Cdocu", width: { wpx: 60} },
                { title: "Ndocu", width: { wpx: 120} },
                { title: "Fecha", width: { wpx: 100} },
                { title: "Fven", width: { wpx: 100} },
                { title: "crefe", width: { wpx: 100} },
                { title: "nrefe", width: { wpx: 100} },
                { title: "frefe", width: { wpx: 100} },
                { title: "ruccli", width: { wpx: 100} },
                { title: "nomcli", width: { wpx: 200} },
                { title: "totalfe", width: { wpx: 120} },
                { title: "TotIna", width: { wpx: 150} },
                { title: "TotExo", width: { wpx: 150} },
                { title: "TotIgv", width: { wpx: 150} },
                { title: "TotNet", width: { wpx: 150} },
                { title: "tcam", width: {wpx: 100}},
                { title: "mone", width: { wpx: 150} },
                { title: "flag", width: { wpx: 150} },
                { title: "codscc", width: { wpx: 150} },
                { title: "codpos", width: { wpx: 150} },
                { title: "Percep", width: { wpx: 80} },
                { title: "cta70", width: { wpx: 80} },
                { title: "cta12", width: { wpx: 80} },
                { title: "feccob", width: { wpx: 120} },
                { title: "abono", width: { wpx: 120} },
                { title: "ctacaja", width: { wpx: 90} },
                { title: "codpagsnt", width: { wpx: 90} },
                { title: "docpago", width: { wpx: 120} },
                { title: "Glosa", width: { wpx: 150} },
            ],
            data: dataReport.map(row => {


                
                return [
                    { value: this.sanitizeValue(row.codigo) },
                    { value: this.sanitizeValue(row.serieNumero) },
                    { value: this.sanitizeValue(row.fechaEmision) },
                    { value: this.sanitizeValue(row.fechaPago || row.fechaEmision) },
                    { value: this.sanitizeValue(row.codDocAfectado) },
                    { value: this.sanitizeValue(row.serieNumeroAfectado) },
                    { value: this.sanitizeValue(row.fechaDocAfectado) },
                    { value: this.sanitizeValue(row.numDocCliente) },
                    { value: this.sanitizeValue(row.razonSocial) },
                    { value: this.sanitizeValue(row.gravadas,3) },
                    { value: this.sanitizeValue(row.inafectas,3) },
                    { value: this.sanitizeValue(row.exoneradas,3) },
                    { value: this.sanitizeValue(row.igv,3) },
                    { value: this.sanitizeValue(row.total,3) },
                    { value: this.sanitizeValue(row.tcam)},
                    { value: this.sanitizeValue(row.moneda) },
                    { value: this.sanitizeValue(row.estadoCe) },
                    { value: this.sanitizeValue(row.codscc) },
                    { value: this.sanitizeValue(row.codpos) },
                    { value: this.sanitizeValue(row.percep) },
                    { value: this.sanitizeValue(row.cta70) },
                    { value: this.sanitizeValue(row.cta12) },
                    { value: this.sanitizeValue(row.fechaPago || row.fechaEmision) },
                    { value: this.sanitizeValue(row.montosPago || row.total) },
                    { value: this.sanitizeValue(row.ctacaja) },
                    { value: this.sanitizeValue(row.codpagsnt) },
                    { value: this.sanitizeValue(row.mediosPago || row.modalidad) },
                    { value: this.sanitizeValue(row.glosa) },
                ]
            })
        }
    ]
}

    render() {
        return (
            <section className="ventas-fpay-section-vh">
                <div className="pt-3 pb-3"
                >
                    <div className="container">
                        <div className="alert alert-warning">
                            La duración de descarga del reporte es directamente proporcional a la cantidad de días y registros
                            comprendidos entre la fecha de inicio y fin.
                        </div>
                    </div>

                    <FiltroReportDocSunat
                        customQueryParams={{ isForVenta: "1" }}
                        isLoading={this.state.isLoading} onFilterPressed={this.onfilterPressedHandler} />
                    {this.state.isLoading ? (
                        <div className="d-flex justify-content-center">
                            <div className="spinner-border" role="status" />
                        </div>
                    ) : null}
                    {this.state.dataReport.length ?
                        <div className="container">
                        <div className="row add-pad">
                            <div className=" alert alert-success  mt-3 col-12 ">
                            Registros encontrados, descargue el siguiente archivo.
                            </div>
                            <div className=" mt-3 d-flex justify-content-center col-12 no-pad">
                                <ExcelFile
                                    element={
                                        // <button className="boton__verdeOscuro" style={{ float: "right" }}>
                                        //     Descargar Excel<i className="fas fa-file-excel" />
                                        // </button>
                                        <button className="btn btn-outline-primary btn-verde-mfp">
                                            Descargar Archivo
                                        </button>
                                    }
                                    filename="reporte-Navasoft"
                                >
                                    <ExcelSheet
                                        dataSet={this.getConfigReport(this.state.dataReport)}
                                        name="Productos"
                                    />
                                </ExcelFile>
                            </div>
                        </div></div> :
                        <div className="container">
                            <div className="alert alert-info mt-3">
                            No se han encontrado registros.
                            </div>
                        </div>
                    }
                </div>
            </section>
        );
    }

}